export const roomsOptions = [
    { value: 0, label: 'All rooms' },
    { value: 1, label: 'Single room' },
    { value: 2, label: 'Separate rooms' }
]; 

export const personsOptions = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' }
]; 

export const reasonOptions = [
    { value: '1', label: 'Business' },
    { value: '2', label: 'Private' }
]; 

export const countriesOptions = [
    { value: 'United States', label: 'United States' },
    { value: 'France', label: 'France' },
    { value: 'Italy', label: 'Italy' }
]; 

